import { useEffect, useState } from "react";
import { fetchMentorDashboardData } from "PlatForms/OrgLMS/Services/MentorServices/DashboardService";
import api from "Common/Client/Interceptor";

const useMentorDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const mentorId = localStorage.getItem("personalId");
        // Parent returns stats/profile only; the trainings and ratings lists
        // were moved to separate paginated endpoints.
        const [data, trainingsRes, ratingsRes] = await Promise.all([
          fetchMentorDashboardData(token),
          api.get("/Training/Mentor/List", {
            params: { mentorId, completed: false, pageNumber: 1, pageSize: 10 },
          }),
          api.get("/TrainingGroup/Mentor/Ratings/List", {
            params: { pageNumber: 1, pageSize: 10 },
          }),
        ]);
        setDashboardData({
          ...data,
          trainings: trainingsRes.data.items || [],
          ratings: ratingsRes.data.items || [],
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { dashboardData, loading, error };
};

export default useMentorDashboard;
